import { useMemo } from 'react';
import { IPaginatedResponse, IPaginationMeta } from '@shared/types/pagination';

export function usePaginatedData<T>(response: IPaginatedResponse<T> | undefined) {
  return useMemo(() => {
    if (!response) {
      return {
        data: [] as T[],
        meta: null as IPaginationMeta | null,
        isEmpty: true,
        isLoading: false,
      };
    }

    const meta: IPaginationMeta = {
      total: response.total,
      currentPage: response.current,
      hasNext: response.next !== null,
      hasPrevious: response.previous !== null,
      nextUrl: response.links?.next || response.next,
      previousUrl: response.links?.previous || response.previous,
    };

    return {
      data: response.results,
      meta,
      isEmpty: response.results.length === 0,
      isLoading: false,
    };
  }, [response]);
}
